"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUnderstrike = void 0;
const retrommo_types_1 = require("retrommo-types");
const pixel_pigeon_1 = require("pixel-pigeon");
const createUnderstrike = ({ condition, width, x, y, }) => {
    const quadrilateralIDs = [];
    quadrilateralIDs.push((0, pixel_pigeon_1.createQuadrilateral)({
        color: retrommo_types_1.Color.DarkGray,
        coordinates: {
            condition,
            x,
            y,
        },
        height: 1,
        width: 1,
    }));
    quadrilateralIDs.push((0, pixel_pigeon_1.createQuadrilateral)({
        color: retrommo_types_1.Color.DarkGray,
        coordinates: {
            condition,
            x: x + 2,
            y,
        },
        height: 1,
        width: 2,
    }));
    quadrilateralIDs.push((0, pixel_pigeon_1.createQuadrilateral)({
        color: retrommo_types_1.Color.DarkGray,
        coordinates: {
            condition,
            x: x + 5,
            y,
        },
        height: 1,
        width: width - 10,
    }));
    quadrilateralIDs.push((0, pixel_pigeon_1.createQuadrilateral)({
        color: retrommo_types_1.Color.DarkGray,
        coordinates: {
            condition,
            x: x + width - 4,
            y,
        },
        height: 1,
        width: 2,
    }));
    quadrilateralIDs.push((0, pixel_pigeon_1.createQuadrilateral)({
        color: retrommo_types_1.Color.DarkGray,
        coordinates: {
            condition,
            x: x + width - 1,
            y,
        },
        height: 1,
        width: 1,
    }));
    return {
        quadrilateralIDs,
    };
};
exports.createUnderstrike = createUnderstrike;
